import {ApiClient} from '@hconnect/apiclient'
import {ApiFilter} from '@hconnect/common/maintain-filters'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'

export const useStoppageListExport = () => {
  return useMutation({
    mutationFn: async (filters?: ApiFilter[]) => {
      const path = '/rootcausefailureanalysis/stoppages/excel'
      const filterPlantIds =
        filters?.find((filterGroup) => filterGroup.property === 'plant')?.values ?? []

      const {data} = await ApiClient.axiosInstance.post(
        path,
        {pageNumber: 0, plantIds: filterPlantIds},
        {
          responseType: 'arraybuffer'
        }
      )
      return new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
    },
    onError: () => spawnErrorToast('Failed to generate excel export', {closeOnClick: true})
  })
}
